import { render, staticRenderFns } from "./itroIndex.vue?vue&type=template&id=5a789bbb&scoped=true&"
import script from "./itroIndex.vue?vue&type=script&lang=js&"
export * from "./itroIndex.vue?vue&type=script&lang=js&"
import style0 from "./itroIndex.vue?vue&type=style&index=0&id=5a789bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a789bbb",
  null
  
)

export default component.exports